export default __webpack_public_path__ + "static/media/noImage.82b77e1b.png";